import React from 'react';
import { Box, Avatar, Typography, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../theme/tokens';
import { usePerson } from '../store/personContext';
import { PROFILE } from '../routes/routes';

const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};

const ROLE_LABEL = { admin: 'Administrador' };

const PersonChip = ({ to = PROFILE }) => {
  const navigate = useNavigate();
  const { person, loading } = usePerson();

  if (loading) {
    return <Skeleton variant="rounded" width={170} height={44} sx={{ borderRadius: '30px' }} />;
  }
  if (!person) return null;

  return (
    <Box
      onClick={() => navigate(to)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        pl: 0.75,
        pr: 1.75,
        py: 0.75,
        border: `1px solid ${tokens.colors.line}`,
        borderRadius: '30px',
        cursor: 'pointer',
        '&:hover': { borderColor: tokens.colors.line2 },
      }}
    >
      <Avatar
        sx={{
          width: 32,
          height: 32,
          fontSize: 12,
          fontWeight: 700,
          backgroundImage: tokens.gradient.avatar,
          color: '#0a0b10',
        }}
      >
        {getInitials(person.full_name)}
      </Avatar>
      <Box sx={{ lineHeight: 1.15 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 640 }}>{person.full_name}</Typography>
        <Typography sx={{ fontSize: 11.5, color: tokens.colors.muted }}>
          {ROLE_LABEL[person.role] || 'Usuario'}
        </Typography>
      </Box>
    </Box>
  );
};

export default PersonChip;